<template>
    <div class="p-3">
        <h3>Kesehatan Kunjungan Rawat Jalan</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="year" class="col-sm-4 col-form-label text-end">Tahun</label>
                    <div class="col-sm-8">
                        <v-select v-model="year" :clearable="false" :multiple="false" :options="data_year" label="name"
                            name="year" id="year" placeholder="Pilih Tahun" :single="true" @input="setYear($event)" />
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-primary" @click="getPel"><i class="fa fa-search"></i>
                            Cari</button>
                    </div>

                </div>
            </div>

        </div>
        <hr />

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Kesehatan Kunjungan Rawat Jalan</div>
            <div class="card-body">
                <div id="table">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Kode RS</th>
                                <th>Nama RS</th>
                                <th>Kab/Kota</th>
                                <th>Jenis Kegiatan</th>
                                <th>Jumlah</th>
                            </tr>

                        </thead>
                        <tbody v-for="(item, index) in data_pel" :key="index">
                            <tr>
                                <td style="text-align: center;">
                                    {{ NomorKodeRS }}
                                </td>
                                <td style="text-align: center;">
                                    {{ NamaRS }}
                                </td>
                                <td style="text-align: center;">
                                    {{ KotaKab }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.NMPoli }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.jumlah_kunjungan }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            year: '',
            NomorKodeRS: '',
            NamaRS: '',
            KotaKab: '',
            data_year: [],
            data_pel: [],

        }
    },
    created() {
    },
    mounted() {
        this.getYear()
        this.getPel()
    },
    methods: {
        setYear(value) {
            this.year = value.id;
        },
        getPel() {
            const uri = `/api/external-kunjungan-rajal/get-pel?year=${this.year}`

            this.axios.get(uri).then(response => {
                const status = response.data.status
                // console.log(status);
                // console.log(response.data.data);

                if (status == 'success') {
                    this.NomorKodeRS = response.data.data_rs.NomorKodeRS;
                    // console.log(response.data.data_rs);
                    this.NamaRS = response.data.data_rs.NamaRS;
                    this.KotaKab = response.data.data_rs.KotaKab;
                    this.data_pel = response.data.data
                    this.data_pel = { ...this.data_pel }
                }
            });

        },
        async getYear() {
            const today = new Date();
            this.year = today.getFullYear();
            try {
                const response = await axios.get(`/api/external-pelayanan/get-year`);
                this.data_year = response.data ?? []
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        },

    }
}
</script>